import React, { useState, useEffect } from "react";
import "./userResetPassword.scss";
import userActivePage from "../../../store/userActivePage";
import authStore from "../../../store/authStore";
import { Box, Stack, TextField, useMediaQuery } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Link, useNavigate } from "react-router-dom";
import brandStore from "../../../store/brandStore";
import { BRAND_NAME_LOGO } from "../../../constant";

const UserResetPassword = ({ oldPassword, title, description }) => {
  const isMobile = useMediaQuery("(max-width: 600px)");
  const navigate = useNavigate();
  const UserActivePage = userActivePage();
  const AuthStore = authStore();
  const BrandStore = brandStore();

  const [email, setEmail] = useState("");
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // window.scrollTo({ top: 0 });
  }, []);

  useEffect(() => {
    if (AuthStore.isLogged) {
      UserActivePage.setIsActive({
        setPage:
          title === "Reset Password?" ? "reset-password" : "forgot-password",
      });
      setEmail(AuthStore.myUser.email);
    }
  }, [AuthStore.isLogged, title]);

  const sendOTP = async () => {
    let flag = 0;
    if (email === "") {
      setIsError(true);
      flag++;
    } else {
      const reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if (reg.test(email) === true) {
        setIsError(false);
      } else {
        setIsError(true);
        flag++;
      }
    }

    if (flag !== 0) return;

    setIsLoading(true);

    const isValidEmail = await AuthStore.validEmailAndSendOTP({
      email,
      whereNavigate:
        title === "Reset Password?" ? "reset-password" : "forgot-password",
    });

    if (isValidEmail) {
      if (AuthStore.isLogged) {
        navigate("/verification/reset-password");
      } else {
        navigate("/verification/reset-password", { replace: true });
      }
    } else {
      setIsError(true);
    }
    setIsLoading(false);
  };

  return (
    <div
      className="forgot-password"
      style={{
        border: !AuthStore.isLogged && "none",
        margin: !AuthStore.isLogged ? (isMobile ? "10px" : "40px") : "",
        padding: !AuthStore.isLogged ? (isMobile ? "10px" : "20px 100px") : "",
      }}
    >
      <Stack spacing={2}>
        {!AuthStore.isLogged && (
          <Box component="div" className="brand-name-logo-container">
            <Link to={"/"} component="div" className="brand-name-logo">
              <img src={BRAND_NAME_LOGO} alt="brand-logo" />
            </Link>
          </Box>
        )}
        <div className="title">{title}</div>
        <div className="description">{description}</div>
        <TextField
          name="email"
          type="email"
          required
          fullWidth
          disabled={AuthStore.isLogged}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          label="Email Address"
          autoComplete="email"
          error={isError}
          helperText={isError && "write valid email"}
        />
        <LoadingButton
          variant="contained"
          loading={isLoading}
          className="btn"
          onClick={sendOTP}
        >
          Send OTP
        </LoadingButton>
      </Stack>
    </div>
  );
};

export default UserResetPassword;
